import { Navigate } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext'; 

export default function ProtectedRoute({ children }) {
    const { token } = useAppContext(); 
    const userId = localStorage.getItem('user_id')

    if (!token || !userId) {
        console.log("Token or User ID is missing, redirecting to login.");
        return <Navigate to="/login" replace />;
    }

    return children;
}
